(() => {
  const normalize = (value) => {
    const trimmed = value.trim();
    if (/^\d[\d\s]*$/.test(trimmed)) return trimmed.replace(/\s+/g, '');
    const match = value.trim().match(/^([A-Za-z0-9]{4})\.([A-Za-z0-9]{2})$/);
    return match && /\d/.test(value) ? match[1] + match[2] : value;
  };
  const compact = (value) => value.toUpperCase().replace(/[ .\/_-]/g, '');
  const isReference = (value) => {
    if (!/\d/.test(value) || !/^[A-Za-z0-9][A-Za-z0-9 .\/_-]*$/.test(value)) return false;
    const parts = value.split(/\s+/);
    if (parts.length > 2 || (parts.length === 2 && (parts[0].length > 4 || !/\d/.test(parts[1])))) return false;
    return /^[A-Z0-9]{4,35}$/.test(compact(value));
  };
  const unwrap = (value) => {
    const spaced = value.match(/^(\d{10})\* OR body:\1\* OR tag:\1\* OR body:"(\d{2} \d{2} \d{3} \d{3})"$/);
    if (spaced && spaced[2].replace(/ /g, '') === spaced[1]) return spaced[1];
    const prefix = value.match(/^(\d{3,35})\* OR body:\1\* OR tag:\1\*$/);
    if (prefix) return prefix[1];
    const match = value.match(/^(.*?) OR body:([A-Z0-9]+) OR tag:\2$/);
    if (!match) return value;
    const terms = match[1].split(' OR ');
    return terms.every((term) => isReference(term) && compact(term) === match[2]) ? terms[0] : value;
  };
  const catalogQuery = (value) => {
    const original = unwrap(value).trim();
    const query = normalize(original);
    if (original !== query && original.includes('.') && isReference(original)) {
      return `${original} OR ${query} OR body:${compact(query)} OR tag:${compact(query)}`;
    }
    if (/^\d{3,35}$/.test(query)) {
      const prefixQuery = `${query}* OR body:${query}* OR tag:${query}*`;
      if (query.length === 10) {
        const spaced = `${query.slice(0, 2)} ${query.slice(2, 4)} ${query.slice(4, 7)} ${query.slice(7)}`;
        return `${prefixQuery} OR body:"${spaced}"`;
      }
      return prefixQuery;
    }
    const undotted = query.match(/^([A-Za-z0-9]{4})([A-Za-z0-9]{2})$/);
    if (undotted && isReference(query)) {
      return `${query} OR ${undotted[1]}.${undotted[2]} OR body:${compact(query)} OR tag:${compact(query)}`;
    }
    return isReference(query) ? `${query} OR body:${compact(query)} OR tag:${compact(query)}` : query;
  };
  window.pwNormalizeOeQuery = normalize;
  window.pwBuildCatalogSearchQuery = catalogQuery;
  document.addEventListener('submit', (event) => {
    const form = event.target;
    if (!(form instanceof HTMLFormElement)) return;
    const action = new URL(form.action, window.location.href);
    if (action.origin !== window.location.origin || !action.pathname.endsWith('/search')) return;
    const input = form.querySelector('input[name="q"]');
    if (input) input.value = catalogQuery(input.value);
  }, true);
  const prepareSearchPage = () => {
    const url = new URL(window.location.href);
    if (!url.pathname.endsWith('/search')) return;
    const query = url.searchParams.get('q');
    if (!query) return;
    const expanded = catalogQuery(query);
    if (expanded !== query) {
      url.searchParams.set('q', expanded);
      window.location.replace(url.toString());
      return;
    }
    const original = unwrap(query);
    if (original === query) return;
    document.querySelectorAll('input[name="q"][type="search"]').forEach((input) => {
      if (input.value === query) input.value = original;
    });
    const root = document.getElementById('MainContent');
    if (root) {
      const walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT);
      let node;
      while ((node = walker.nextNode())) {
        if (!/^(SCRIPT|STYLE)$/.test(node.parentElement?.tagName || '') && node.nodeValue.includes(query)) {
          node.nodeValue = node.nodeValue.split(query).join(original);
        }
      }
    }
    document.title = document.title.split(query).join(original);
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', prepareSearchPage, { once: true });
  else prepareSearchPage();
})();
